import Konva from "konva";

/**
 * Global Konva settings, applied once before the first Stage mounts.
 *
 * `hitOnDragEnabled`: Konva skips Stage pointer/touch events while any node
 * (including the draggable Stage itself) is dragging. A one-finger pan starts
 * a Stage drag after 3px, so without this the second finger's `touchmove`
 * never reaches `useStagePanZoom.onTouchMove` and pinch-to-zoom silently
 * degrades into a pan. Konva's own multi-touch example sets it for the same
 * reason.
 */
Konva.hitOnDragEnabled = true;
